import React from 'react';

import {
  FEATURE_GATES,
  PermissionFilter,
  GlobalFeatureGateFilter
} from '@ubisend/pulse-auth';
import {
  Panel,
  PageWrapper
} from '@ubisend/pulse-components';

import { Resource } from '../Components';

const DocumentPage = () => (
  <PageWrapper beta="true" header="Document" subheader="Configure your Document">
    <GlobalFeatureGateFilter for={FEATURE_GATES.GENERATIVE_AI}>
      <PermissionFilter can="view generative ai resource">
        <Panel>
          <Resource />
        </Panel>
      </PermissionFilter>
    </GlobalFeatureGateFilter>
  </PageWrapper>
);

export default DocumentPage;